import { useTranslation } from 'react-i18next'

import { getEpostFormFieldsRegisteredLetterOptions } from '../../../Epost'
import { TableTextCell } from '../../../Table'

function RegisteredLetterCell({ value, ...restProps }) {
  const { t } = useTranslation()

  const letterValue = getEpostFormFieldsRegisteredLetterOptions(t).find(
    item => item.value === value
  )?.label

  return <TableTextCell {...restProps} value={letterValue} />
}

export default RegisteredLetterCell
